module.exports = __webpack_public_path__ + "media/images/wrong_icon-0b5ff3181e3e4745c336580a69a73e12.png";